import { useCallback, useState } from 'react';

import { trackTabActivity, trackTabExit } from '@/features/administration/contract/utils';

export const useTabAnalytics = () => {
    const [startTime, setStartTime] = useState<number>(Date.now());
    const [currentTab, setCurrentTab] = useState<number>(0);

    const handleTabChange = useCallback(
        (newTabIndex: number): void => {
            trackTabExit(currentTab, startTime);
            trackTabActivity(newTabIndex, currentTab);

            setCurrentTab(newTabIndex);
            setStartTime(Date.now());
        },
        [currentTab, startTime]
    );

    return {
        handleTabChange,
    };
};
